import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { PollPopupProps } from 'reactApp/ui/PollPopup/PollPopup';
import { noopVoid } from 'reactApp/utils/helpers';

export const renderPollPopup = ({ onClose = noopVoid, isPhone = false, onSubmit }: PollPopupProps) =>
    openPopupHelper({ popupName: popupNames.POLL_DIALOG, data: { isPhone, onSubmit }, onClose });

export const closePollPopup = () => closePopupHelper(popupNames.POLL_DIALOG);
